import { render, staticRenderFns } from "./ProductsGrid.vue?vue&type=template&id=0744bfaf&"
import script from "./ProductsGrid.vue?vue&type=script&lang=ts&"
export * from "./ProductsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsGrid.vue?vue&type=style&index=0&id=0744bfaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports